export default "__VITE_ASSET__Bc9ZyNdt__ 72w";